import { DemographicSettingModel } from './DemographicSetting'
import { IpAreaSettingModel } from './IpAreaSetting'
import { WeeklyDeliveryScheduleModel } from './WeeklyDeliverySchedule'

export class AdvancedSettingModel {
  constructor(data) {
    const {
      deliveryDevices,
      deliveryInventories,
      inventoryListOptionalIds,
      onlyJapaneseDevice,
      weeklyDeliverySchedule,
      demographicSetting,
      ipAreaSetting,
    } = data

    this.deliveryDevices = deliveryDevices
    this.deliveryInventories = deliveryInventories
    this.inventoryListOptionalIds = inventoryListOptionalIds
    this.onlyJapaneseDevice = onlyJapaneseDevice
    this.weeklyDeliverySchedule =
      weeklyDeliverySchedule == null
        ? weeklyDeliverySchedule
        : weeklyDeliverySchedule.map(WeeklyDeliveryScheduleModel.assign)
    this.demographicSetting = new DemographicSettingModel(demographicSetting)
    this.ipAreaSetting = new IpAreaSettingModel(ipAreaSetting)
  }

  static assign(data) {
    return new AdvancedSettingModel(data)
  }
}
